import UmbracoBase from './UmbracoBase';

export default class ScrollToDiv extends UmbracoBase {
	constructor(args) {
		// Inheriting form UmbracoBase
		super(args);

		this.componentName = 'scroll-to-div';

		this.icon = args.icon;

		this.textColor = args.textColor;
		this.overrideTextColor = args.overrideTextColor;
		// override text color
		if (this.overrideTextColor) {
			this.textColor.color = this.overrideTextColor;
		} else if (this.textColor.color) {
			this.textColor.color = '#' + this.textColor.color;
		} else {
			this.textColor.color = 'black';
		}

		this.backgroundColor = args.backgroundColor;
		this.overrideBackgroundColor = args.overrideBackgroundColor;

		this.scrollToDivId = args.scrollToDivId;
		this.scrollToComponentIndex = args.scrollToComponentIndex - 1;

		// // Override background color

		// if(this.overrideBackgroundColor){
		//     this.backgroundColor.color = this.overrideBackgroundColor;
		// }else if(this.backgroundColor.color){
		//     this.backgroundColor.color = '#' + this.backgroundColor.color;
		// }else{
		//     this.backgroundColor.color = "none";
		// }

		this.contentBackgroundColor = args.contentBackgroundColor;
		this.overrideContentBackgroundColor = args.overrideContentBackgroundColor;
		if (this.overrideContentBackgroundColor) {
			this.contentBackgroundColor.color = this.overrideContentBackgroundColor.replace('#', '');
		} else if (this.contentBackgroundColor) {
			this.contentBackgroundColor.color = '#' + this.contentBackgroundColor.color;
		} else {
			this.contentBackgroundColor.color = 'none';
		}
	}
}
